import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { userConfigurationQuery } from './user-configuration.selectors';
import { UserConfigurationPartialState } from '.';
import * as userConfigurationActions from './user-configuration.actions';
import { BuildTripViewType } from '@sd-portal/shared/models';

@Injectable({ providedIn: 'root' })
export class UserConfigurationFacade {
  /** configs */
  calendarConfiguration$ = this.store.pipe(select(userConfigurationQuery.getCalendarConfiguration));

  externalProvidersConfiguration$ = this.store.pipe(
    select(userConfigurationQuery.getExternalProvidersConfiguration)
  );

  constructor(private readonly store: Store<UserConfigurationPartialState>) {}

  /** init */
  init() {
    this.store.dispatch(userConfigurationActions.initFeature());
  }

  updateUseFlattenedCalendar(useFlattenedCalendar: boolean) {
    this.store.dispatch(
      userConfigurationActions.toggleUseFlattenedCalendar({ useFlattenedCalendar })
    );
  }

  isLockTripEnabled(): Observable<boolean> {
    return this.externalProvidersConfiguration$.pipe(
      map(extProvidersConfiguration => extProvidersConfiguration.isLockTripEnabled)
    );
  }

  isAdmin(): Observable<boolean> {
    return this.externalProvidersConfiguration$.pipe(
      map(extProvidersConfiguration => extProvidersConfiguration.isAdmin)
    );
  }

  getDefaultTripStatusId(): Observable<number | null> {
    return this.externalProvidersConfiguration$.pipe(
      map(extProvidersConfiguration => extProvidersConfiguration.defaultTripStatusId)
    );
  }

  getBuildTripViewTypeId(): Observable<BuildTripViewType> {
    return this.calendarConfiguration$.pipe(
      map(calConfiguration => calConfiguration.buildTripViewTypeId)
    );
  }
}
